export default __webpack_public_path__ + "static/media/icon-play.38872d03.svg";